import React from "react";
import aboutSectionRight from "../../assets/images/about/aboutSectionRight.webp"; // replace with actual image path
import lmsIcon from "../../assets/images/about/lms.svg"; // replace with actual LMS icon
import erpIcon from "../../assets/images/about/erp.svg"; // replace with actual ERP icon



const AboutSection = () => {
  return (
    <section className="w-full px-4 md:px-12 md:py-10 py-6  bg-white">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center gap-10">
        {/* Left - Text Content */}
        <div className="md:w-1/2 space-y-6">
          <h2 className="text-2xl md:text-3xl">Who <span className="font-outfitLight">We Are</span></h2>
          <p className="leading-relaxed font-outfitRegular">
            Edupro Hub is your all-in-one <span className="font-bold">digital partner for coaching institutes</span> — 
            designed to help students get the exact experience of real competitive exams before the actual day, 
            through full-scale <span className="font-bold">Computer-Based Test </span>(CBT) simulations.
          </p>
          <p className=" leading-relaxed font-outfitRegular">
            Our services include <span className="font-bold">pan-India exam center bookings</span>, 
            <span className="font-bold"> admit card generation</span>, 
            <span className="font-bold"> candidate document verification</span>, 
            frisking protocols, 
            and <span className="font-bold"> strict invigilation</span>—ensuring students feel the pressure, 
            structure, and authenticity of a real examination.
          </p>

          <h3 className="md:text-2xl text-xl font-outfitLight  mt-4">
            We Also Offer <span className="font-bold">Smart Tech Tools</span> Like:
          </h3>

          <div className="flex flex-col sm:flex-row gap-4 bg-white rounded-lg shadow-md">
            {/* LMS Card */}
            <div className="flex items-center p-4   w-full sm:w-1/2">
            <div className="bg-[#F5F5F5] p-3 mr-4 h-full flex justify-center items-center rounded-md shrink-0">
              <img src={lmsIcon} alt="LMS Icon" className="w-10" />
            </div>
              <p className="text-sm ">
                <span className="font-semibold">LMS & ERP Systems{" "}</span>
                To manage batches, fees, content, and communication
              </p>
            </div>

            {/* ERP Card */}
            <div className="flex items-center p-4 w-full sm:w-1/2">
            <div className="bg-[#F5F5F5] p-3 mr-4 h-full flex justify-center items-center rounded-md shrink-0">
              <img src={erpIcon} alt="LMS Icon" className="w-10 " />
            </div>        
                  {/* <p className="text-sm ">
                <span className="font-semibold">Smart Communication Tools</span>
                For centralized access, updates & performance tracking
              </p> */}
            </div>
          </div>

          <p className="leading-relaxed mt-4 font-outfitRegular">
            Whether you're a <span className="font-bold">local coaching center</span> or a 
            <span className="font-bold"> national-level institute</span>, Edupro Hub helps you grow, train smarter, 
            and bridge the gap between preparation and performance — enhancing your students’ 
            <span className="font-bold"> confidence</span>, reducing exam anxiety, and improving outcomes.
          </p>
        </div>

        {/* Right - Image */}
        <div className="md:w-1/2 flex justify-center">
          <img
            src={aboutSectionRight}
            alt="Edupro Hub Presenter"
            loading="lazy"
            decoding="async"
            className="max-w-xs md:max-w-md object-contain"
          />
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
